<template>
  <div
    :class="[
      'border rounded-3xl p-5',
      cardData.onFocus ? ' border-primaryColor border-4' : 'border-gray-300',
    ]"
    style="max-width: 290px;"
  >
    <h4
      :class="[
        'text-xl font-semibold',
        cardData.onFocus ? ' text-primaryColor ' : ' text-gray-800',
      ]"
    >
      {{ cardData.title }}
    </h4>
    <p class="text-base font-medium text-gray-700 mt-5">
      {{ cardData.description }}
    </p>
    <h3 class="text-3xl font-semibold mt-5 mb-0">
      ${{ activeTab === 'monthly' ? cardData.monthly : cardData.yearly }}
      <span class="text-base text-gray-700"
        >/ month
      </span>
    </h3>
    <p class=" italic text-base font-medium text-gray-700"> {{ activeTab === 'monthly' ? 'Per user' : 'Per user billed annually' }} </p>
    <button
      :class="[
        'btn w-full hover:bg-primaryColor',
        cardData.onFocus ? ' btn-primary ' : 'btn-outline',
      ]"
    >
      Get Started
    </button>
    <ul :class="['mt-10']">
      <li
        class="mt-5"
        v-for="(data, index) in cardData.keyPoints"
        :key="index + data.title"
      >
        <font-awesome-icon
          class="reaction text-gray-800 mr-4 font-thin"
          size="lg"
          :icon="['fas', 'check']"
        />
        {{ data.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PricingCard',
  props: ['cardData', 'activeTab', 'index'],
};
</script>

<style>
</style>
